import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import { colors } from "../../theme/colors";
import ToggleButton from "../common/ToggleButton";

const TOGGLE_ROW_SX = {
    display: "grid",
    gridTemplateColumns: "1fr 4.5rem",
    alignItems: "center",
    gap: "0.5rem",
    py: "0.95rem",
    borderTop: `1px solid ${colors.border.subtle}`,
};

export default function MMPreferenceToggleRow({
    setting,
    onToggleChange,
    disabled = false,
}) {
    const checked = Boolean(setting.toggleState);

    return (
        <Box
            sx={{
                ...TOGGLE_ROW_SX,
                opacity: disabled ? 0.55 : 1,
            }}
        >
            <Typography
                sx={{
                    color: colors.text.primary,
                    fontSize: "0.9rem",
                    fontWeight: 600,
                    lineHeight: 1.3,
                    minWidth: 0,
                }}
            >
                {setting.title}
            </Typography>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                }}
            >
                <ToggleButton
                    active={checked}
                    disabled={disabled}
                    onClick={() => onToggleChange(setting.id, !checked)}
                />
            </Box>
        </Box>
    );
}

MMPreferenceToggleRow.propTypes = {
    setting: PropTypes.shape({
        id: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        toggleState: PropTypes.bool,
    }).isRequired,
    onToggleChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
};
